<!-- src/components/projects/Locations.vue -->
<template>
  <div class="container">
    <div class="row justify-content-end">
      <div class="col-md-6">
        <div class="input-group">
          <input
            v-model="name"
            type="text"
            class="form-control"
            placeholder="Enter Location Name"
            @keyup.enter="addLocation"
          />
          <button
            class="btn btn-success"
            @click="addLocation"
            :disabled="isAdding || !name.trim()"
          >
            <i class="bi bi-plus-circle"></i> Add
          </button>
        </div>
        <span v-if="errorMessage" class="text-danger mt-1">
          {{ errorMessage }}
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Location Name</th>
              <th style="width: 60px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="location in locations" :key="location.id">
              <td>{{ location.id }}</td>
              <td>
                <input
                  v-if="editingId === location.id"
                  v-model="editingName"
                  class="form-control"
                  placeholder="New Name"
                  @keyup.enter="saveEdit(location.id)"
                />
                <span v-else>{{ location.name }}</span>
              </td>
              <td>
                <div class="btn-group btn-group-sm">
                  <button
                    v-if="editingId === location.id"
                    @click="saveEdit(location.id)"
                    class="btn btn-secondary btn-sm"
                  >
                    <i class="fas fa-save"></i>
                  </button>
                  <button
                    v-else
                    @click="editLocation(location)"
                    class="btn btn-secondary btn-sm"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                  <button
                    @click="deleteLocation(location.id)"
                    class="btn btn-danger btn-sm"
                  >
                    <i class="far fa-trash-alt"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { useProjectStore } from "@/stores/projectStore";
import { ref, computed } from "vue";

export default {
  setup() {
    const store = useProjectStore();
    const name = ref("");
    const editingId = ref(null);
    const editingName = ref("");
    const errorMessage = ref("");
    const isAdding = ref(false);
    const locations = computed(() => store.getAllLocations());

    const addLocation = async () => {
      if (!name.value.trim()) {
        errorMessage.value = "Location name is required.";
        return;
      }

      isAdding.value = true;
      errorMessage.value = "";
      try {
        await store.createLocation({ name: name.value.trim() });
        name.value = "";
      } catch (error) {
        errorMessage.value = "Failed to add location.";
      } finally {
        isAdding.value = false;
      }
    };

    const editLocation = (location) => {
      editingId.value = location.id;
      editingName.value = location.name;
    };

    const saveEdit = async (id) => {
      if (!editingName.value.trim()) {
        errorMessage.value = "New name is required.";
        return;
      }

      try {
        await store.updateLocation(id, editingName.value.trim());
        editingId.value = null;
        editingName.value = "";
      } catch (error) {
        errorMessage.value = "Failed to save changes.";
      }
    };

    const deleteLocation = async (id) => {
      try {
        await store.deleteLocation(id);
      } catch (error) {
        errorMessage.value = "Failed to delete location.";
      }
    };

    return {
      locations,
      name,
      editingId,
      editingName,
      errorMessage,
      isAdding,
      addLocation,
      editLocation,
      saveEdit,
      deleteLocation,
    };
  },
};
</script>

<style scoped>
.location-container {
  padding: 20px;
}

.table {
  margin-top: 20px;
}

.text-danger {
  font-size: 0.9em;
}
</style>
